import { lazy, Suspense, type ComponentType, type LazyExoticComponent } from 'react';
import type { RouteObject } from 'react-router';
import { TallyLoader } from '../shared/components/tally-loader';
import { buildRoutes } from './build-routes';

function page<K extends string>(
  load: () => Promise<Record<K, ComponentType>>,
  name: K,
): LazyExoticComponent<ComponentType> {
  return lazy(async () => ({ default: (await load())[name] }));
}

const DashboardPage = page(() => import('../features/dashboard/pages/dashboard-page'), 'DashboardPage');
const TransactionsPage = page(
  () => import('../features/transactions/pages/transactions-page'),
  'TransactionsPage',
);
const SettingsPage = page(() => import('../features/settings/pages/settings-page'), 'SettingsPage');
const ProfilePage = page(() => import('../features/profile/pages/profile-page'), 'ProfilePage');
const JoinPage = page(() => import('../features/sharing/pages/join-page'), 'JoinPage');

function withSuspense(Page: LazyExoticComponent<ComponentType>) {
  return (
    <Suspense fallback={<TallyLoader label="Membuka halaman" className="py-10" />}>
      <Page />
    </Suspense>
  );
}

export const appRoutes: RouteObject[] = buildRoutes({
  dashboard: withSuspense(DashboardPage),
  transactions: withSuspense(TransactionsPage),
  settings: withSuspense(SettingsPage),
  profile: withSuspense(ProfilePage),
  join: withSuspense(JoinPage),
});
